module.exports = __webpack_public_path__ + "static/media/portugal.6eff3ead.JPG";